<template>
  <div class="whole">
    <div :class="{cur_pointer:adLinkUrl,banner:true}" :style="{ backgroundImage: 'url( ' + banner + ')'}" @click="themeLink(adLinkUrl)"></div>

    <div class="container1" ref="refContent">
      <!-- 风格 -->
      <dl class="cate_item" :class="{'show':styleMore}">
        <dt class="label"> 风格 </dt>
        <dd class="content" ref="styleContentRef">
          <div class="td-list">
            <span class="td_item com_link" :class="{active:query.styleChildSerNo === undefined}" @click="sureCategory(undefined)">全部</span>
            <span class="td_item com_link" :class="{active:query.styleChildSerNo === item.serNo}" v-for="(item, index) in styleList" :key="index" @click="sureCategory(item.serNo)">
              {{ item.name }}
            </span>
          </div>
          <div class="td-more" v-if="styleContentHeight>45">
            <span class="com_link" @click="styleMore = !styleMore">
              <span>{{styleMore?"收起":'更多'}}</span>
              <i :class="styleMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </span>
          </div>
        </dd>
      </dl>
      <!-- 价格区间 -->
      <dl class="cate_item border2">
        <dt class="label"> 价格 </dt>
        <dd class="content">
          <div class="td-list">
            <span class="td_item com_link" :class="{active:query.minPrice === item.minPrice}" v-for="(item, index) in priceList" :key="index" @click="surePrice(item)">
              {{ item.name }}
            </span>
          </div>
        </dd>
      </dl>
      <div class="list">
        <div class="item" v-for="(v,i) in list" :key="i">
          <router-link class="img mask" :to="{path:'wholeBagDetail',query:{themeNo:v.themeNo}}" target="_blank">
            <img v-lazy="v.mainPreviewImageFilePath">
          </router-link>
          <div class="flex">
            <div class="logo">
              <!-- <img v-lazy="img2"> -->
            </div>
            <div class="name">
              <p class="title com_hidden">{{v.name}}</p>
              <p class="sub_title com_hidden">
                <span>{{v.houseTypeBedroom+"室"}}</span>
                <span>{{v.houseTypeHall+"厅"}}</span>
                <span>{{v.houseTypeBathroom+"卫"}}</span>
              </p>
            </div>
            <div class="price">
              <p class="money" v-if="v.totalPrice">￥{{v.totalPrice}}</p>
              <router-link :to="{path:'wholeBagDetail',query:{themeNo:v.themeNo}}" target="_blank">
                <el-button class="btn" type="primary">套餐详情</el-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 没有商品 -->
      <div class="no_goods" v-if="!total">产品正在更新上架，敬请期待。</div>
      <el-pagination v-if="list.length" class="pagination" background @current-change="handleCurrentChange" :current-page="pageInfo.pageNumber" :page-size="pageInfo.pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetGoodsWholeSearchBasicInfo,
  GetGoodsWholeSearchPageList,
  GetAdPositionId,
} from "@/pages/page1/api/modules/home";
export default {
  metaInfo: { title: "整装拎包 - 多比商城" },
  data() {
    return {
      banner: "",
      adLinkUrl: "",
      styleList: [],
      styleMore: false,
      styleContentHeight: 45,
      priceList: [
        { name: "全部", minPrice: null, maxPrice: null },
        { name: "12000以下", minPrice: 0, maxPrice: 12000 },
        { name: "12000 ～ 25000", minPrice: 12000, maxPrice: 25000 },
        { name: "25000以上", minPrice: 25000, maxPrice: null },
      ],
      query: {
        styleChildSerNo: undefined,
        minPrice: null,
        maxPrice: null,
      },
      list: [],
      total: 1,
      pageInfo: {
        pageNumber: 1,
        pageSize: 10,
        searchProperty: [],
        orderProperty: [],
      },
      img2: require("@/assets/img/brandLogo2.jpg"),
    };
  },
  mounted() {
    let query = this.$route.query;
    Object.assign(this.query, query);
    delete this.query.page;
    // 字符串转数字
    for (const key in this.query) {
      if (typeof this.query[key] === "string") {
        this.query[key] = parseInt(this.query[key]);
      }
    }
    // 锚点定位,用户体验
    if (
      typeof this.query.minPrice === "number" ||
      typeof this.query.styleChildSerNo === "number"
    ) {
      this.scrollInto("refContent");
    }
    // console.log(this.query);
    this.pageInfo.pageNumber = this.$route.query.page || 1;
    this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
    this.getBasicInfo();
    // 获取背景图
    let adPositionId = this.$configId.adPositionId;
    this.getBanner(adPositionId.wholeBag);
  },
  methods: {
    getBasicInfo() {
      GetGoodsWholeSearchBasicInfo().then((res) => {
        // console.log("获取基础属性", res);
        this.styleList = res.data[0].styleList;
        this.getList();
        // 更多按钮展示控制
        this.getHeightForMore("styleContentRef", "styleContentHeight", 45);
      });
    },
    getHeightForMore(ref, typeHeight, height) {
      this.$nextTick(() => {
        let ele = this.$refs[ref];
        try {
          this[typeHeight] = ele.clientHeight || height;
        } catch (error) {}
      });
    },
    getList() {
      let params = {
        pageInfo: this.pageInfo,
        wholeType: 0,
        ...this.query,
      };
      GetGoodsWholeSearchPageList(params)
        .then((res) => {
          // console.log("获取列表", res);
          this.list = res.data;
          this.total = res.count;
        })
        .catch(() => {
          this.total = 0;
        });
    },
    getBanner(id) {
      let params = {
        adPositionId: id,
        themeCount: 1,
        contentCount: 0,
        loadNoConTheme: 1, //不过滤没有内容的主题
      };
      GetAdPositionId(params).then((res) => {
        // console.log("当前页banner", res);
        try {
          this.banner = res.data[0].themeFileUrl;
          this.adLinkUrl = res.data[0].adLinkUrl;
        } catch (error) {}
      });
    },
    sureCategory(serNo) {
      this.query.styleChildSerNo = serNo;
      this.reloadSearch();
    },
    surePrice(item) {
      if (this.query.minPrice === item.minPrice) return;
      this.query.minPrice = item.minPrice;
      this.query.maxPrice = item.maxPrice;
      this.reloadSearch();
    },
    // 页面刷新
    reloadSearch(page) {
      let query = {
        ...this.query,
        page: page ? page : undefined,
      };
      // 优化地址栏参数展示
      if (query.minPrice === null) {
        query.minPrice = undefined;
      }
      if (query.maxPrice === null) {
        query.maxPrice = undefined;
      }
      // console.log(query);
      // return;
      let newUrl = this.$router.resolve({
        path: "wholeBagList",
        query,
      });
      window.open(newUrl.href, "_self");
    },
    // 分页
    handleCurrentChange(val) {
      // console.log(val);
      this.reloadSearch(val);
    },
    scrollInto(refName) {
      let element = this.$refs[refName];
      element.scrollIntoView();
    },
    // 主题位置跳转
    themeLink(url) {
      if (!url) {
        return false;
      }
      if (url.indexOf("http") == -1) {
        url = "http://" + url;
      }
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.whole {
  color: #333333;
  font-size: 14px;
  padding-bottom: 60px;
  .banner {
    height: 546px;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 32px;
  }
  .cate_item {
    border-top: 1px solid #afafaf;
    height: 38px;
    overflow: hidden;
    .label {
      width: 90px;
      line-height: 38px;
      padding-left: 6px;
      float: left;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      width: calc(100% - 96px);
      box-sizing: border-box;
      padding: 7px 4px 7px 14px;
      margin-left: 96px;
      display: flex;
      .td-list {
        width: 90%;
        box-sizing: border-box;
        line-height: 14px;
        .td_item {
          display: inline-block;
          margin-right: 30px;
          margin-bottom: 7px;
          border: none;
          padding: 5px 7px;
          cursor: pointer;
          font-weight: 500;
        }
        .active {
          background-color: @themeColor;
          color: #ffffff !important;
        }
      }
      .td-more {
        width: 10%;
        text-align: right;
        padding-top: 3px;
      }
    }
  }
  .border2 {
    border-bottom: 1px solid #afafaf;
  }
  .show {
    height: auto;
  }
  .list {
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    // min-height: 530px;
    .item {
      width: calc((100% - 30px) / 2);
      height: 506px;
      background: #f1f1f1;
      border: 1px solid #afafaf;
      box-sizing: border-box;
      padding: 10px;
      margin-right: 30px;
      margin-top: 24px;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .img {
        display: block;
        height: 370px;
      }
      .flex {
        height: 68px;
        margin-top: 22px;
        .logo {
          width: 130px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          // background: #ffffff;
          margin-right: 30px;
          img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
        .name {
          width: 270px;
          height: 100%;
          box-sizing: border-box;
          line-height: 1;
          padding: 13px 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title {
            font-size: 18px;
            font-weight: bold;
            width: 100%;
          }
          .sub_title {
            font-weight: 400;
            width: 100%;
          }
        }
        .price {
          padding-top: 13px;
          width: calc(100% - 430px);
          box-sizing: border-box;
          padding-left: 6px;
          line-height: 1;
          text-align: right;
          .money {
            color: #d00000;
            font-weight: bold;
          }
          .btn {
            margin-top: 10px;
            height: 30px;
            width: 110px;
            padding: 0;
            background: #d00000;
            border-radius: 10px;
          }
        }
      }
    }
  }
  .no_goods {
    position: relative;
    top: 30px;
    height: 200px;
    line-height: 200px;
    font-size: 14px;
    font-weight: 700;
    background-color: #fffdee;
    border: 1px solid #edd28b;
    text-align: center;
  }
  .pagination {
    text-align: right;
    margin-top: 38px;
  }
  .mask {
    position: relative;
    cursor: pointer;
    line-height: 1;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>